import { FooterDataDto } from '@asset-metrix/portal-gateway-client-js';
import { IAggFuncParams, IRowNode } from 'ag-grid-community';

function getGroupDataKeys(rowNode: IRowNode<unknown>): string[] {
  let key = rowNode.key;

  // Temp handling "null" as a key use case in the group footer api eg: {"2019": 1234, "null": 5678}
  // TODO: Align with BE team to fix this special case handling in portal API
  if (key === '') {
    key = 'null';
  }

  if (key == null) {
    return [];
  }
  if (rowNode.parent == null) {
    return [key];
  }
  return [...getGroupDataKeys(rowNode.parent), key];
}

export const getGroupFooterAggregationFunc = (
  deepestGroupLevel = 0,
  footerDataGroups: FooterDataDto['groups']
) => {
  return ({ colDef, rowNode }: IAggFuncParams) => {
    if (colDef.field == null || footerDataGroups?.[colDef.field] == null) {
      return;
    }

    const groupDataKeys = getGroupDataKeys(rowNode);
    if (
      groupDataKeys.length === 0 ||
      groupDataKeys.length < deepestGroupLevel + 1
    ) {
      // if data keys are undefined or we have not reached the bottom level, just return
      return;
    }

    let groupData: any = footerDataGroups?.[colDef.field];

    for (const key of groupDataKeys) {
      if (groupData?.[key] == null) {
        // no data available at this depth
        return;
      }
      // pass the deeper level data into the next iteration
      // until we reach the last key and finally return the value found
      groupData = groupData[key];
    }
    return groupData;
  };
};
